// extracted by mini-css-extract-plugin
export var closeButton = "_m3-2";
export var closeButtonIcon = "_m3-3";
export var lightboxContent = "_m3-1";
export var lightboxOverlay = "_m3-0";